module.exports = __webpack_public_path__ + "static/media/gift.9a427578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gift.jpg
// module id = 321
// module chunks = 6